import { useState, useEffect, useReducer, useContext } from 'react';
import Card from '../../Template/components/UI/Card/Card';
import Button from '../../Template/components/UI/Button/Button';
import AuthContext from '../../store/auth-context';
import { useNavigate } from 'react-router-dom';
import { LoginLoader } from '../../Template/components/UI/Modal/Spinner';
import { getBaseUrl } from '../../utils/getUrl';
import './Login.css';
import { useTranslation } from 'react-i18next';
import useHttp from '../../Template/hooks/use-http';
import axios from 'axios';
import { requestPermissionAndGetToken } from '../../firebase';
import { setLanguageCookie } from '../../utils/languageCookie';
// import toast from 'react-hot-toast';

// Validacija username polja (trenutno samo length > 1 promeniti po potrebi)
const usernameReducer = (state, action) => {
  if (action.type === 'USER_INPUT') {
    return { value: action.val, isValid: action.val.trim().length > 1 };
  }
  if (action.type === 'INPUT_BLUR') {
    return { value: state.value, isValid: state.value.trim().length > 1 };
  }
  return { value: '', isValid: false };
};

// Validacija password polja (trenutno samo length > 1 promeniti po potrebi)
const passwordReducer = (state, action) => {
  if (action.type === 'USER_INPUT') {
    return { value: action.val, isValid: action.val.trim().length > 1 };
  }
  if (action.type === 'INPUT_BLUR') {
    return { value: state.value, isValid: state.value.trim().length > 1 };
  }
  return { value: '', isValid: false };
};

function Login() {
  const apiBaseUrl = process.env.REACT_APP_API_CHAT_PROD;
  const { t, i18n } = useTranslation();
  const api = getBaseUrl();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [alertOpacity, setOpacity] = useState('0');
  const [formIsValid, setFormIsValid] = useState(false);
  const [passwordType, setPasswordType] = useState('password');
  const authContext = useContext(AuthContext);
  const { sendRequest: getLanguages, data: langData } = useHttp('');
  const [usernameState, dispatchUsername] = useReducer(usernameReducer, {
    value: '',
    isValid: null,
  });
  const [passwordState, dispatchPassword] = useReducer(passwordReducer, {
    value: '',
    isValid: null,
  });

  const [permission, setPermission] = useState('');
  const [fbtoken, setFbtoken] = useState();

  const { isValid: usernameIsValid } = usernameState; // Aalias
  const { isValid: passwordIsValid } = passwordState;

  useEffect(() => {
    const identifier = setTimeout(() => {
      setFormIsValid(usernameIsValid && passwordIsValid);
    }, 500);
    return () => {
      clearTimeout(identifier);
    }; // clean up function
  }, [usernameIsValid, passwordIsValid]); // ovde saljemo samo property isvalid a ne ceo objekat
  // mogli smo da kazemo i usernameState.isValid isto bi dobili

  const usernameChangeHandler = (event) => {
    dispatchUsername({ type: 'USER_INPUT', val: event.target.value });
  };

  const passwordChangeHandler = (event) => {
    dispatchPassword({ type: 'USER_INPUT', val: event.target.value });
  };

  const validateUsernameHandler = () => {
    dispatchUsername({ type: 'INPUT_BLUR' });
  };

  const validatePasswordHandler = () => {
    dispatchPassword({ type: 'INPUT_BLUR' });
  };

  const upisiJWTToken = async (idKorisnika, token) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/Login/update_jwt_token`,
        {
          userId: idKorisnika,
          token: token,
        },
      );
      if (response) {
        console.log('UPISAN TOKEN');
      } else {
        console.error('Invalid credentials');
      }
    } catch (error) {
      console.error('Greška prilikom dohvatanja poruka:', error);
    }
  };

  const vracanjeTokena = async (item) => {
    const token = await requestPermissionAndGetToken();
    localStorage.setItem('fbtoken', token);
    console.log(token);

    const axios = require('axios');
    const FormData = require('form-data');
    const formData = new FormData();

    if (token) {
      formData.append('idKorisnika', item.idKorisnika);
      formData.append('token', token);
      try {
        await axios.post(
          `https://cloud3.okta.rs:20044/api/Login/upisi_token_korisnika`,
          formData,
        );
        console.log('✅ Token upisan uspešno:', token);

        // await toast.success({
        //   text: '✅ Token je uspešno upisan.',
        //   duration: 'long',
        // });
      } catch (error) {
        console.log('❌ Greška sa unosom tokena', error);

        // const errorMsg =
        //   (error && error.message) ||
        //   (typeof error === 'string' ? error : JSON.stringify(error)) ||
        //   'Nepoznata greška pri slanju tokena.';

        // await toast.error({
        //   text: `❌ Greška pri upisu tokena: ${errorMsg}`,
        //   duration: 'long',
        // });
      }
    }

    setFbtoken(token);
    return token;
  };

  const vratiTokenJWT = async (idKorisnika) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/Login/vrati_podatke_korisnika`,
        {
          idKorisnika: idKorisnika,
        },
      );

      return response.data;
    } catch (error) {
      console.error('Greška prilikom dohvatanja poruka:', error);
    }
    return null;
  };

  useEffect(() => {
    const configLang = {
      url: `combo/vrati_jezike_za_prevod_combo`,
    };
    getLanguages(configLang);
  }, []);

  const submitHandler = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    const axios = require('axios');
    const FormData = require('form-data');
    const formData = new FormData();

    formData.append('KorisnickoIme', usernameState.value);
    formData.append('Lozinka', passwordState.value);

    const config = {
      method: 'POST',
      url: `${api}login`,
      data: formData,
    };

    try {
      const response = await axios(config);
      setIsLoading(false);

      if (response.data !== '') {
        const korisnikId = response.data.idKorisnika;
        const expirationTime = new Date(
          new Date().getTime() + +response.data.trajanjeTokena * 1000,
        );

        let chatToken = '';

        const korisnikPodaci = await axios.post(
          `${apiBaseUrl}/Login/vrati_podatke_korisnika`,
          {
            idKorisnika: korisnikId,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          },
        );

        if (korisnikPodaci.data?.email && korisnikPodaci.data?.Password) {
          const loginResponse = await axios.post(`${apiBaseUrl}/Login/login`, {
            email: korisnikPodaci.data.email,
            password: korisnikPodaci.data.Password,
          });

          chatToken = loginResponse.data.token;

          if (loginResponse.data?.token) {
            upisiJWTToken(korisnikId, loginResponse.data.token);
          }
        }

        authContext.login(
          response.data.token,
          expirationTime.toISOString(),
          korisnikId,
          response.data.korisnik,
          response.data.idMenija,
          response.data.slikaURL,
          response.data.magacioner,
          response.data.boja,
          response.data.supervizor,
          response.data.sa,
          response.data.idOsobe,
          response.data.idOrgJed,
          response.data.idKupca,
          chatToken,
          response.data.uniqueUser,
        );

        localStorage.setItem('noviToken', 'true');
        vracanjeTokena(response.data);
        navigate('/');
      } else {
        setOpacity('1');
        setTimeout(() => {
          setOpacity('0');
        }, 1500);

        // await toast.error({
        //   text: '❗ Neispravno korisničko ime ili lozinka.',
        //   duration: 'long',
        // });
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Greška pri logovanju:', error);

      // const poruka =
      //   error?.response?.data?.message ||
      //   error?.message ||
      //   'Došlo je do greške pri logovanju.';

      // await toast.error({
      //   text: `❌ ${poruka}`,
      //   duration: 'long',
      // });
    }
  };

  const initLogin = async (username, password) => {
    const token = localStorage.getItem('token');

    if (token) {
      navigate('/', { replace: true });
      return;
    }
    if (!username || !password) {
      return;
    }
    setIsLoading(true);

    const axios = require('axios');
    const FormData = require('form-data');
    const formData = new FormData();

    formData.append('KorisnickoIme', username);
    formData.append('Lozinka', password);

    const config = {
      method: 'POST',
      url: `${api}login`,
      data: formData,
    };

    try {
      const response = await axios(config);
      setIsLoading(false);

      if (response.data !== '') {
        const korisnikId = response.data.idKorisnika;
        const expirationTime = new Date(
          new Date().getTime() + +response.data.trajanjeTokena * 1000,
        );

        let chatToken = '';

        const korisnikPodaci = await axios.post(
          `${apiBaseUrl}/Login/vrati_podatke_korisnika`,
          {
            idKorisnika: korisnikId,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
            credentials: 'include',
          },
        );

        if (korisnikPodaci.data?.email && korisnikPodaci.data?.Password) {
          const loginResponse = await axios.post(`${apiBaseUrl}/Login/login`, {
            email: korisnikPodaci.data.email,
            password: korisnikPodaci.data.Password,
          });

          chatToken = loginResponse.data.token;

          if (loginResponse.data?.token) {
            upisiJWTToken(korisnikId, loginResponse.data.token);
          }
        }

        authContext.login(
          response.data.token,
          expirationTime.toISOString(),
          korisnikId,
          response.data.korisnik,
          response.data.idMenija,
          response.data.slikaURL,
          response.data.magacioner,
          response.data.boja,
          response.data.supervizor,
          response.data.sa,
          response.data.idOsobe,
          response.data.idOrgJed,
          response.data.idKupca,
          chatToken,
          response.data.uniqueUser,
        );

        localStorage.setItem('noviToken', 'true');
        vracanjeTokena(response.data);
        navigate('/');
      } else {
        setOpacity('1');
        setTimeout(() => {
          setOpacity('0');
        }, 1500);

        // await toast.error({
        //   text: '❗ Neispravno korisničko ime ili lozinka.',
        //   duration: 'long',
        // });
      }
    } catch (error) {
      setIsLoading(false);
      console.error('Greška pri logovanju:', error);

      // const poruka =
      //   error?.response?.data?.message ||
      //   error?.message ||
      //   'Došlo je do greške pri logovanju.';

      // await toast.error({
      //   text: `❌ ${poruka}`,
      //   duration: 'long',
      // });
    }
  };

  useEffect(() => {
    const dashboardOrigin = 'https://cloud3.okta.rs:20063';

    const handleMessage = (event) => {
      if (event.origin !== dashboardOrigin) {
        return;
      }

      if (event.data?.type !== 'INIT_LOGIN') {
        return;
      }

      const { username, password } = event.data;

      if (!username || !password) {
        return;
      }

      const token = localStorage.getItem('token');
      if (token) {
        navigate('/', { replace: true });
        return;
      }

      // zapamti da je ovaj tab već obradio dashboard login
      sessionStorage.setItem('dashboardLaunchHandled', '1');

      // prekini vezu sa dashboard-om da logout ne može opet da okine auto-login
      try {
        window.opener = null;
      } catch (error) {
        console.log('Nije moguće poništiti window.opener:', error);
      }
      initLogin(username, password);
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useEffect(() => {
    const dashboardOrigin = 'https://cloud3.okta.rs:20063';

    if (!window.opener) {
      return;
    }

    const dashboardLaunchHandled = sessionStorage.getItem(
      'dashboardLaunchHandled',
    );

    if (dashboardLaunchHandled === '1') {
      return;
    }

    sessionStorage.setItem('dashboardLaunchHandled', '1');

    const token = localStorage.getItem('token');

    if (token) {
      navigate('/', { replace: true });
      return;
    }

    window.opener.postMessage(
      {
        type: 'APP_READY_FOR_LOGIN',
      },
      dashboardOrigin,
    );
  }, []);

  const handleClickEye = () => {
    if (passwordType === 'password') {
      setPasswordType('text');
    } else {
      setPasswordType('password');
    }
  };
  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    setLanguageCookie(selectedLanguage);
  };
  return (
    <div className="login-back">
      <div
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/loginBackground.jpg)`,
          width: '56%',
        }}
        className="levaSlika"
      />

      <div
        style={{
          width: '44%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '100vh',
          alignItems: 'center',
        }}
      >
        <Card className="login">
          <form onSubmit={submitHandler}>
            <div
              className={`${'control'} ${
                usernameState.isValid === false ? 'invalid' : ''
              }`}
            >
              <label htmlFor="username">{t('userName')}</label>
              <input
                type="text"
                id="username"
                // autoComplete="off"
                value={usernameState.value}
                onChange={usernameChangeHandler}
                onBlur={validateUsernameHandler}
              />
              <i
                className="fas fa-user"
                style={{ marginLeft: '-30px', color: '#464646' }}
              />
            </div>
            <div
              className={`${'control'} ${
                usernameState.isValid === false ? 'invalid' : ''
              }`}
            >
              <label htmlFor="password">{t('password')}</label>
              <input
                type={passwordType}
                id="password"
                // autoComplete="off"
                value={passwordState.value}
                onChange={passwordChangeHandler}
                onBlur={validatePasswordHandler}
              />
              {passwordType === 'password' && (
                <i
                  className="fas fa-eye"
                  style={{
                    marginLeft: '-31px',
                    cursor: 'pointer',
                    marginRight: '-3px',
                    color: '#464646',
                  }}
                  onClick={handleClickEye}
                />
              )}
              {passwordType === 'text' && (
                <i
                  className="fas fa-eye-slash"
                  style={{
                    marginLeft: '-33px',
                    cursor: 'pointer',
                    marginRight: '-3px',
                    color: '#464646',
                  }}
                  onClick={handleClickEye}
                />
              )}
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
              className="actions"
            >
              {!isLoading && (
                <Button
                  style={{ width: '50%' }}
                  type="submit"
                  className="btn"
                  disabled={!formIsValid}
                >
                  {t('buttons.logIn')}
                </Button>
              )}
              {isLoading && (
                <span>
                  <LoginLoader />
                </span>
              )}
              <select
                onChange={handleLanguageChange}
                value={i18n.language}
                style={{
                  width: '200px',
                  border: 'none', // Uklanjanje okvira
                  padding: '8px', // Dodavanje paddinga za bolji izgled
                  borderRadius: '5px', // Zaobljene ivice
                  backgroundColor: '#f0f0f0', // Svetlo siva boja pozadine
                  color: '#333', // Boja teksta
                  cursor: 'pointer', // Stil pokazivača kao pokazivač
                  outline: 'none',
                  marginTop: '20px',
                }}
              >
                {langData?.map((item) => {
                  return <option value={item.vrednost}>{item.vrednost}</option>;
                })}
              </select>
            </div>
          </form>
        </Card>

        <div className="span_alert" style={{ opacity: alertOpacity }}>
          <span>{t('messages.incorrectUserOrPassword')}</span>
        </div>
      </div>
    </div>
  );
}

export default Login;
